export default "__VITE_ASSET__CrEwiVcU__"